import { ContentfulCardLegacy } from '@reward-platform/contentful'
import { SearchTabQuery } from '~/schemas/searchPageParams'
import Link from 'next/link'
import React from 'react'
import { usePlatformRoutes } from '~/context/platform'
import { getContentfulImageProps } from '~/utils/assets'
import { trackCtaClick } from './MediaCard.utils'
import ImageCard from './ImageCard'

type Props = {
  card: ContentfulCardLegacy
  product: SearchTabQuery
}

export function MediaCard({
  card: { image, bynderImage, heading, link, caption, destinationAirport },
  product,
}: Readonly<Props>) {
  const { createRoutePath } = usePlatformRoutes()
  const { imgSrc, imgAlt } = getContentfulImageProps({
    bynderImage,
    image,
    fallbackAlt: heading,
  })
  const hasBynderImage = bynderImage?.some((item) => item.selectedFile?.url || item.src)
  const imageAlt = hasBynderImage ? imgAlt : `${image.title} ${image.description}`

  const content = (
    <ImageCard
      data-testid="card"
      src={imgSrc}
      alt={imageAlt}
      height={200}
      width={300}
      objectFit="cover"
      sizes="(max-width: 650px) 80vw, 300px"
      aria-hidden
    >
      <ImageCard.Caption heading={heading}>{caption}</ImageCard.Caption>
    </ImageCard>
  )

  if (link?.length) {
    return (
      <Link href={createRoutePath(link)} passHref>
        {content}
      </Link>
    )
  }

  if (product === 'flights' && destinationAirport) {
    return (
      <Link
        data-testid="interactive-card"
        onClick={() => trackCtaClick(destinationAirport)}
        prefetch={false}
        shallow
        title={`${heading} ${caption}`}
        href={{
          query: {
            tab: 'flights',
            toAirportCode: destinationAirport,
            oneWayOnly: false,
          },
        }}
      >
        {content}
      </Link>
    )
  }
  return content
}
